import {
  Card,
  CardContent,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import dayjs from 'dayjs';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {ExamModule} from '@cp/model';

interface ExamModuleListProps {
  examModules: ExamModule[];
  onEdit: (module: ExamModule) => void;
  onDelete: (module: ExamModule) => void;
  onView: (module: ExamModule) => void;
}

export default function ExamModuleList({examModules, onEdit, onDelete, onView}: ExamModuleListProps) {
  return (
    <Card>
      <CardContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Level</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Exam Board</TableCell>
                <TableCell>Required Role</TableCell>
                <TableCell>Questions Per Topic</TableCell>
                <TableCell>Number of Topics</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {examModules.map((module: ExamModule) => (
                <TableRow key={module.id}>
                  <TableCell>{module.name}</TableCell>
                  <TableCell>
                    <Chip label={module.level} size="small" />
                  </TableCell>
                  <TableCell>
                    <Chip label={module.subject} size="small" color="primary" />
                  </TableCell>
                  <TableCell>{module.examBoard || '-'}</TableCell>
                  <TableCell>{module.requiredRole || '-'}</TableCell>
                  <TableCell>{module.questionsPerTopic || '-'}</TableCell>
                  <TableCell>{module.topics.length}</TableCell>
                  <TableCell>{dayjs(module.createdAt).format('MMM DD, YYYY')}</TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => onView(module)} sx={{color: '#1B263B'}}>
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => onEdit(module)} sx={{color: '#1B263B'}}>
                      <EditIcon />
                    </IconButton>
                    <IconButton size="small" onClick={() => onDelete(module)} sx={{color: '#FF6F59'}}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
